import {h, Fragment} from "preact"
const ListItems = ({ amount = 4 }) => {
    return [...Array(amount).keys()].map(idx => (
        <div class={`placeholder-item shimmer-animation`} key={`placeholder-${idx}`}>
            <div class="background-mask under-image-mask" />
            <div class="background-mask title-mask" />
            <div class="background-mask under-title-mask" />
            <div class="background-mask rating-mask" />
            <div class="background-mask under-rating-mask" />
            <div class="background-mask description-mask" />
            <div class="background-mask mid-description-mask" />
            <div class="background-mask under-description-mask" />
            <div class="background-mask price-mask" />
        </div>
    ));
};

export default (props) => {
    return (
        <>
            <div id="plp-sidebar" class="mt-4">
                <div class="placeholder-item shimmer-animation"></div>
            </div>
            <div class="placeholder-list">
                <ListItems {...props} />
            </div>
        </>
    );
}
